import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
]

export default function SelectEnabled({...props}) {
    const myProps = {
        placeholder: 'Enabled?',
        firstSelect: true, 
        isClearable: true, 
        options: OPTIONS,
        icon: {icon: 'check'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}